import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'paymentGatewayPublicKey',
  initialState: null as string | null,
  reducers: {
    setPaymentGatewayPublicKey(state, action: PayloadAction<string>) {
      return action.payload || null;
    },
  },
});

export const { setPaymentGatewayPublicKey } = slice.actions;

export default slice.reducer;
